const PrimaryJobInterest = [
    "AR/VR",
    "Artificial Intelligence",
    "Back-end Developer",
    "Blockchain",
    "Data Engineer",
    "Data Science",
    "Database Developer",
    "DevOps",
    "Drupal",
    "Embedded Developer",
    "Front-end Developer",
    "Game Developer",
    "IT Security",
    "Magento",
    "Mobile Developer",
    "Quality Assurance, Full Stack",
    "Quality Assurance, Manual",
    "React Developer",
    "RPA",
    "Salesforce",
    "UI Developer",
    "Web (Full Stack) Developer",
    "WordPress"
  ];
  
  module.exports = PrimaryJobInterest;
  